((app, ng) => {

    app.component("investmentAccount",
        {
            templateUrl: "/App/Client/Case/Accounts/InvestmentAccounts/investment-account.html",
            controller: investmentAccountController,
            bindings: {
                client: "<",
                account: "<",
                custodians: "<",
                investmentAccountTypes: "<",
                planTypes: "<",
                currentUser: "<",
                toggleCollapse: "&",
                onAccountDeleted: "&"
            }
        });

    function investmentAccountController(caseModalService, clientApi, customFieldApi, FieldStatusesModel, fileViewerModalService, _formPattern, investmentAccountApi, _investmentAccountStatuses, moment, responseStatus) {
        const $ctrl = this;
        ng.extend($ctrl,
            {
                ui: {saving: false},
                updateAccount: updateAccount,
                updateAccountCustodian: updateAccountCustodian,
                updateAccountInvestmentAccountType: updateAccountInvestmentAccountType,
                updateAccountDateOpened: updateAccountDateOpened,
                updateCustomField: updateCustomField,
                deleteAccount: deleteAccount,
                openNotes: openNotes,
                openDirectory: openDirectory
            });

        function updateCustomField(updatedField, fieldIndex){
            $ctrl.savingStatusForCustomFields.fields[fieldIndex].startSaving();
            $ctrl.ui.saving = true;
            //console.log(updatedField);
            //sanitize custom field entry
            var updateEntry = {
                Id: updatedField.Id,
                CustomFieldId: updatedField.CustomFieldId,
                CaseId: updatedField.CaseId,                              
                AccountId: updatedField.AccountId,
                TextAnswer: !!updatedField.TextAnswer ? updatedField.TextAnswer : '',
                DateTimeAnswer: !!updatedField.DateTimeAnswer ? new Date(updatedField.DateTimeAnswer) : null,
                TextOptionsAnswerList: null
            };
            return customFieldApi.updateAccountEntry(updateEntry)
                .then((response) => {
                    $ctrl.savingStatusForCustomFields.fields[fieldIndex].succeed();
                    if (!!response) { updatedField.Id = response.Id; }
                })
                .catch((error) => {
                    console.log("Error", error);
                    $ctrl.savingStatusForCustomFields.fields[fieldIndex].fail();                    
                })
                .finally(() => { $ctrl.ui.saving = false;});
        }

        function updateAccount(account, editedField){
            $ctrl.savingStatusAccount.findFieldStatusByName(editedField).startSaving();
            investmentAccountApi.update(account.InvestmentAccountId, account)
                .then(() => {
                    $ctrl.savingStatusAccount.findFieldStatusByName(editedField).succeed();
                }).catch(() => {
                    $ctrl.savingStatusAccount.findFieldStatusByName(editedField).fail();
                });
        }

        function updateAccountCustodian(account, editedField){
            $ctrl.savingStatusAccount.findFieldStatusByName(editedField).startSaving();
            investmentAccountApi.updateCustodian(account.InvestmentAccountId, account)
                .then(() => {
                    $ctrl.savingStatusAccount.findFieldStatusByName(editedField).succeed();
                }).catch(() => {
                    $ctrl.savingStatusAccount.findFieldStatusByName(editedField).fail();
                });
        }

        function updateAccountInvestmentAccountType(account, editedField){
            $ctrl.savingStatusAccount.findFieldStatusByName(editedField).startSaving();
            investmentAccountApi.updateInvestmentAccountType(account.InvestmentAccountId, account)
                .then(() => {
                    $ctrl.savingStatusAccount.findFieldStatusByName(editedField).succeed();
                }).catch(() => {
                    $ctrl.savingStatusAccount.findFieldStatusByName(editedField).fail();
                });
        }

        function updateAccountDateOpened(account, dateStr, editedField) {
            const datePattern = new RegExp($ctrl.formPattern.date);

            if (!!dateStr && datePattern.test(dateStr)) {
                account.DateOpened = new Date(dateStr);

                $ctrl.updateAccount(account, editedField);
            }
        }

        function deleteAccount(accountId) {
            caseModalService.confirmAccountDeletion().then(() => {
                $ctrl.onAccountDeleted({ accountId });

                investmentAccountApi.delete(accountId);
            });
        }

        function openNotes($event) {
            caseModalService.openInvestmentAccountNotes($ctrl.account.InvestmentAccountId, $ctrl.currentUser, $event);
        }

        function openDirectory($event) {
            fileViewerModalService.openInvestmentAccountDirectory($ctrl.account.InvestmentAccountId,
                $ctrl.currentUser,
                $ctrl.client,
                $event);
        }

        $ctrl.$onInit = () => {
            $ctrl.formPattern = _formPattern;
            $ctrl.investmentAccountStatuses = _investmentAccountStatuses;
            $ctrl.dateOpened = $ctrl.account.DateOpened ? moment.utc($ctrl.account.DateOpened).format("L") : null;
            $ctrl.savingStatusAccount = new FieldStatusesModel($ctrl.account);
            $ctrl.savingStatusForCustomFields = new FieldStatusesModel($ctrl.account.CustomFields);
            $ctrl.responseStatus = responseStatus;
            _.forEach($ctrl.account.CustomFields, (field) => {
                if (field.CustomFieldType === 'DateTime') {
                    field.AccountEntryModel.DateTimeAnswer = field.AccountEntryModel.DateTimeAnswer ? moment.utc(field.AccountEntryModel.DateTimeAnswer).format("L") : null;
                }
            });
        }
    }

})(window.app, window.angular);